import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/AxiosInstance";

const AISummarization = () => {
  // single "module" config for ChatGPT key
  const [enabled, setEnabled] = useState(false);
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [showKey, setShowKey] = useState(false);
  const [message, setMessage] = useState("");

  // Load user ChatGPT key settings from backend on mount
  useEffect(() => {
    async function fetchSettings() {
      setLoading(true);
      try {
        const res = await axiosInstance.get("search/modules/settings/");
        // Find ChatGPT module settings from backend (assuming moduleName === "ChatGPT")
        const chatgptModule = res.data.find(
          (m) => m.moduleName === "ChatGPT"
        );
        if (chatgptModule) {
          setEnabled(chatgptModule.enabled ?? false);
          setApiKey(chatgptModule.apiKey ?? "");
        }
      } catch (err) {
        console.error("Failed to load ChatGPT API key settings", err);
        setMessage("Error loading settings.");
      } finally {
        setLoading(false);
      }
    }
    fetchSettings();
  }, []);

  const handleToggle = () => {
    setEnabled((prev) => !prev);
  };

  const handleSave = async () => {
    setLoading(true);
    setMessage("");
    try {
      const payload = [
        {
          moduleName: "ChatGPT",
          enabled,
          apiKey,
          apiSecret: "", // Not used here
          weight: 1.0,   // Not used here but required by backend format
        },
      ];
      await axiosInstance.post("search/modules/settings/", payload);
      setMessage("Settings saved successfully!");
    } catch (err) {
      console.error("Failed to save settings", err);
      setMessage("Error saving settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">ChatGPT API Key Settings</h2>
      <div className="mb-6 p-4 border border-gray-700 rounded bg-gray-800 text-white">
        <div className="flex items-center justify-between mb-4">
          <span className="text-xl font-semibold">ChatGPT</span>
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={enabled}
              onChange={handleToggle}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-purple-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600 relative" />
            <span className="ml-3 text-sm font-medium text-gray-200">
              {enabled ? "Enabled" : "Disabled"}
            </span>
          </label>
        </div>
        <div className="relative">
          <input
            type={showKey ? "text" : "password"}
            placeholder="Enter your ChatGPT API Key"
            value={apiKey}
            onChange={(e) => {
                const val = e.target.value;
                setApiKey(val);
                if (val.trim() !== "") setEnabled(true);
            }}
            className="w-full p-2 bg-gray-700 border border-gray-600 rounded"
            />

          <button
            type="button"
            onClick={() => setShowKey((v) => !v)}
            className="absolute top-2 right-2 text-sm text-gray-300"
          >
            {showKey ? "Hide" : "Show"}
          </button>
        </div>
      </div>

      <button
        onClick={handleSave}
        disabled={loading}
        className={`mt-6 px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        {loading ? "Saving..." : "Save"}
      </button>
      {message && (
        <p
          className={`mt-4 text-sm ${
            message.toLowerCase().includes("error")
              ? "text-red-500 dark:text-red-400"
              : "text-green-400"
          }`}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default AISummarization;
